import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FeatherIconNames} from 'feather-icons';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule, FeatherPipe],
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() outline: boolean = false;
  @Input() type: 'success' | 'danger' | 'warning' | 'info' = 'info';
  @Input() icon?: FeatherIconNames | null = null;
  @Input() iconSize: number = 16;
}
